import { render, staticRenderFns } from "./ManualConsolidationWizardModal.vue?vue&type=template&id=05c421a5"
import script from "./ManualConsolidationWizardModal.vue?vue&type=script&lang=ts"
export * from "./ManualConsolidationWizardModal.vue?vue&type=script&lang=ts"
import style0 from "./ManualConsolidationWizardModal.vue?vue&type=style&index=0&id=05c421a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports